module.exports = __webpack_public_path__ + "img/guizhouHints_3.9444c99f.jpg";